import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useConfirmUserMutation } from 'services/user';
import toast from 'react-hot-toast';
import { useClaim } from './useClaim';

export const useConfirmClaim = (network, company) => {
  const params = new URLSearchParams(window.location.search);
  const collectionId = network?.id;
  const organizationId = company?.id;
  const confirmationToken = params.get('confirmation_token');

  const [confirmUser, { isLoading: isConfirmingUser }] = useConfirmUserMutation();
  const history = useHistory();

  const { claimOrganization } = useClaim();

  useEffect(() => {
    const isConfirming = confirmationToken && collectionId && organizationId;

    if (isConfirming) {
      confirmUser({ confirmationToken, collectionId, organizationId })
        .unwrap()
        .then(async (response) => {
          await claimOrganization({ activeNetwork: network, company, userData: response });
        })
        .catch(() => {
          toast('Failed to confirm user or claim organization', {
            icon: 'error',
            id: 'confirm-claim-error',
          });
          history.push('/login');
        });
    }
  }, [confirmationToken, collectionId, organizationId, confirmUser, history, claimOrganization, network, company]);

  return { isConfirmingUser: isConfirmingUser || confirmationToken };
};
